export const MONTHS = ['Ock', 'Sbt', 'Mar', 'Nsn', 'May', 'Haz', 'Tem', 'Ağu', 'Eyl', 'Eki', 'Kas', 'Ara'];
export const baseDateValues = {year:2024,month:0,day:1}
export const baseDate = new Date(baseDateValues.year, baseDateValues.month, baseDateValues.day)
export const monthNames = [
	"Ocak",
	"Şubat",
	"Mart",
	"Nisan",
	"Mayıs",
	"Haziran",
	"Temmuz",
	"Ağustos",
	"Eylül",
	"Ekim",
	"Kasım",
	"Aralık",
]


export const intervalMapping = {
    'hour': 'HOUR',
    '2hours': 'TWO_HOURS',
    '6hours': 'SIX_HOURS',
    'day': 'DAY',
    'week': 'WEEK',
    '2weeks': 'TWO_WEEKS',
    'month': 'MONTH',
    '3months': 'THREE_MONTHS',
    'year': 'YEAR',
    '10year': 'TEN_YEAR',
  };


  export const INTERVALS = {
	// SIX_HOURS: { value: "6hours", pixelWidth: 50 },
	DAY: { value: "day", pixelWidth: 60 },
	WEEK: { value: "week", pixelWidth: 70 },
	TWO_WEEKS: { value: "2weeks", pixelWidth: 90 },
	MONTH: { value: "month", pixelWidth: 80 },
	THREE_MONTHS: { value: "3months", pixelWidth: 100 },
	YEAR: { value: "year", pixelWidth: 90 },
	TEN_YEAR: { value: "10years", pixelWidth: 80 },
	HUNDRED_YEAR: { value: "100years", pixelWidth: 100 },
	THOUSAND_YEAR: { value: "1000years", pixelWidth: 100 },
}



export const zoomLevels = [
    { value: 'day', label: '■■■■■' },
    // { value: 'week', label: 'Haftalık' },
    // { value: '2weeks', label: '2 Haftalık' },
    { value: 'month', label: '■■■■▢' },
    { value: '3months', label: '■■■▢▢' },
    { value: 'year', label: '■■▢▢▢' },
    { value: '10years', label: '■▢▢▢▢' },
    { value: '100years', label: '▢▢▢▢▢' }
  ];
